const ContactInformation = () => {
  return (
    <div className="mb-8">
      <h2 id="changes-privacy-notice" className="text-2xl font-semibold mb-4">Changes to this privacy notice</h2>
      <p className="mb-6">We reserve the right to alter this privacy notice at any time. Such alterations will be posted on our App. You can also obtain an up-to-date copy of our privacy notice by contacting us.</p>

      <h2 id="contacting-us" className="text-2xl font-semibold mb-4">Contacting us</h2>
      <p className="mb-6">If you would like to contact us to understand more about this Policy or wish to contact us concerning any matter relating to individual rights and your Personal Information, you may do so via the contact us or email us.</p>
      <p className="mb-6">WhooShare BV</p>
      <p className="mb-6">Netherlands</p>
    </div>
  );
};

export default ContactInformation;